import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const selectors = {
  stickyCard: "[data-sticky-card]",
};

const initStickyCardAnimation = (stickyCard) =>
  gsap
    .timeline({
      scrollTrigger: {
        trigger: stickyCard,
        start: "center center",
        end: "max",
        scrub: true,
      },
    })
    .to(
      stickyCard,
      {
        ease: "power1",
        scrollTrigger: {
          trigger: stickyCard,
          start: "center center",
          end: "+=100%",
          scrub: true,
        },
      },
      0
    )
    .to(
      stickyCard,
      {
        ease: "power1",
        scale: 0.75,
        yPercent: -50,
      },
      0
    );

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const stickyCards = document.querySelectorAll(selectors.stickyCard);

    stickyCards?.forEach(initStickyCardAnimation);
  },
  {
    once: true,
  }
);
